var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPhoneIcon = function SvgPhoneIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 61"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "red"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 60,
    x: 0.5,
    y: 0.5,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 44,
    x: 5.5,
    y: 5.5,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 1,
    x: 13.5,
    y: 54.5,
    rx: 0.5
  }))));
};
export default SvgPhoneIcon;